(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["international-availability"] && !Shopify.designMode) return;
  try {
    
const internationalAvailability = {
  rootClass: 'international-availability--available',
  restrictedClass: 'international-availability--restricted',

  /**
   * @returns {HTMLElement|null}
   */
  getSection() {
    return document.querySelector('.international-availability[data-enabled="true"]');
  },

  /**
   * @param {HTMLElement} section
   * @returns {string[]}
   */
  getCountryCodes(section) {
    return section.dataset.countryCodes
      .split(/[\s,]+/)
      .map((countryCode) => countryCode.trim().toUpperCase())
      .filter(Boolean);
  },

  /**
   * @returns {Promise<string>}
   */
  async getDetectedCountry() {
    const fallbackCountry = window.Shopify && window.Shopify.country ? window.Shopify.country : '';
    const fallbackLanguage = window.Shopify && window.Shopify.language ? window.Shopify.language : '';
    const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    const url = new URL(`${root}browsing_context_suggestions.json`, window.location.origin);

    url.searchParams.set('country[enabled]', 'true');
    url.searchParams.set('language[enabled]', 'true');

    if (fallbackCountry) {
      url.searchParams.set('country[exclude]', fallbackCountry);
    }

    if (fallbackLanguage) {
      url.searchParams.set('language[exclude]', fallbackLanguage);
    }

    try {
      const response = await fetch(url.toString());

      if (!response.ok) {
        throw new Error(`Country detection failed with ${response.status}`);
      }

      const data = await response.json();
      const detectedCountry = data.detected_values && data.detected_values.country
        ? data.detected_values.country.handle
        : fallbackCountry;

      return detectedCountry ? detectedCountry.toUpperCase() : '';
    } catch (error) {
      console.error('International availability country detection failed:', error);
      return fallbackCountry ? fallbackCountry.toUpperCase() : '';
    }
  },

  /**
   * @param {HTMLElement} section
   * @param {string} countryCode
   * @returns {boolean}
   */
  isAvailable(section, countryCode) {
    const countryCodes = this.getCountryCodes(section);
    const isListedCountry = countryCodes.includes(countryCode);

    if (section.dataset.mode === 'exclude') {
      return countryCode ? !isListedCountry : true;
    }

    return countryCode ? isListedCountry : false;
  },

  /**
   * @param {boolean} available
   * @returns {void}
   */
  setAvailability(available) {
    document.documentElement.classList.toggle(this.rootClass, available);
    document.documentElement.classList.toggle(this.restrictedClass, !available);
  },

  /**
   * @returns {Promise<void>}
   */
  async init() {
    const section = this.getSection();

    if (!section) {
      document.documentElement.classList.remove(this.rootClass, this.restrictedClass);
      return;
    }

    const countryCode = await this.getDetectedCountry();
    this.setAvailability(this.isAvailable(section, countryCode));
  },

  /**
   * @param {ShopifySectionEvent} event
   * @returns {void}
   */
  unload(event) {
    const section = this.getSection();

    if (section && section.dataset.sectionId !== event.detail.sectionId) return;

    document.documentElement.classList.remove(this.rootClass, this.restrictedClass);
  }
};

internationalAvailability.init();

document.addEventListener('shopify:section:load', () => {
  internationalAvailability.init();
});

document.addEventListener('shopify:section:unload', (event) => {
  internationalAvailability.unload(event);
});

document.addEventListener('shopify:section:select', () => {
  internationalAvailability.init();
});

document.addEventListener('shopify:section:deselect', () => {
  internationalAvailability.init();
});

document.addEventListener('shopify:block:select', () => {
  internationalAvailability.init();
});

document.addEventListener('shopify:block:deselect', () => {
  internationalAvailability.init();
});

  } catch(e) { console.error(e); }
})();
})();
